module.exports = __webpack_public_path__ + "static/media/undraw_work_from_anywhere_7sdx.f08fbc46.svg";